import { schema } from 'normalizr';

export const commentSchema = new schema.Entity('comments', {});

export const taskSchema = new schema.Entity('tasks', {});

export const annotationSchema = new schema.Entity('annotations', {
  comments: [commentSchema],
  task: taskSchema,
});

export const shareSchema = new schema.Entity('shares', {});

export const channelEventSchema = new schema.Entity('channelEvents', {});

export const channelSchema = new schema.Entity('channels', {
  annotations: [annotationSchema],
  shares: [shareSchema],
  channelEvents: [channelEventSchema],
});
